<template>
  <group :title="title" class="traces">
    <cell v-for="(item, index) in traces" :key="index" class="traces_item">
      <div slot='icon' class="trace_status">
        <i class="status_line" :class="{'status_line_blue': item.status !== 'not_started'}"></i>
        <i class="icon" :class="iconClass[item.status]"></i>
      </div>
      <div slot="after-title" class="trace_info">
        <slot :step="item"></slot>
      </div>
    </cell>
  </group>
</template>
<script>
import { Group, Cell } from '@lx-frontend/cvux'

export default {
  props: {
    title: {
      type: String,
      default: '审核流程'
    },
    traces: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    Group,
    Cell
  },
  data() {
    return {
      iconClass: {
        pending_review: 'status_waiting',
        approved: 'status_ok',
        rejected: 'status_no',
        not_started: 'original'
      }
    }
  }
}

</script>
<style lang="less">
@import "../../stylesheets/modules/components/steps.less";
</style>
